import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { stripLangPrefix, SUPPORTED_LANGS } from '@/hooks/useLocalizedPath';

const BASE_URL = 'https://www.taxisalzburg.net';

const HreflangTags = () => {
  const { pathname } = useLocation();
  const cleanPath = stripLangPrefix(pathname);

  return (
    <Helmet>
      {SUPPORTED_LANGS.map((lang) => (
        <link
          key={lang}
          rel="alternate"
          hrefLang={lang}
          href={`${BASE_URL}/${lang}${cleanPath === '/' ? '' : cleanPath}`}
        />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${BASE_URL}/de${cleanPath === '/' ? '' : cleanPath}`}
      />
    </Helmet>
  );
};

export default HreflangTags;
